/** This form's `kind` in `CreateEntityWizardStore` — a `submitRequest`/`resetRequest` only triggers this component's handlers when its `tab` matches. */
export const FACILITY_FORM_KIND = 'facility' as const;

/** Shape of the Facility tab's Signal Form model. Same rationale as `OrganizationFormValue` — flat, plain-string fields, no shared/Material types. */
export interface FacilityFormValue {
    name: string;
    type: string;
    addressLine1: string;
    city: string;
    state: string;
    zipCode: string;
    country: string;
}

export const DEFAULT_FACILITY_FORM_VALUE: FacilityFormValue = {
    name: '',
    type: '',
    addressLine1: '',
    city: '',
    state: '',
    zipCode: '',
    country: ''
};
